import {mapActions, mapGetters, mapMutations} from "vuex";
import {HEADER_NOTIFICATION_SHOW_TOOLTIP} from '@/store/mutation-types';
import {
    HEADER_FETCH_NOTIFICATION_COURSES,
    HEADER_READ_ALL_NOTIFICATIONS,
    HEADER_REMOVE_ALL_NOTIFICATIONS,
    HEADER_REMOVE_NOTIFICATION,
} from '@/store/action-types';
import moment from 'moment';

import CloseIcon from './components/close.vue';

export default {
    name: 'notifications-tooltip',
    components: {
        CloseIcon,
    },
    filters: {
        convertDate(value) {
            if (!value) return '';
            return moment(value).format('DD.MM.YYYY HH:mm')
        }
    },
    data() {
        return {
            coords: {
                x: 0,
                y: 0,
            },
            itemIndex: 0,
            isTitleDisplay: false,
            titleTimer: null,
        }
    },
    computed: {
        tooltipTitleText() {
            if (!this.list.length) return '';
            return this.list[this.itemIndex].isReaded ? 'прочитанное' : 'непрочитанное';
        },
        ...mapGetters({
            list: 'header/notificationsList',
            loading: 'header/notificationRequestStatus',
        }),
        showLabelMore() {
            if (this.list) {
                return this.list.length > 3 && !this.loading;
            }
            return false;
        }
    },
    created() {
        if (!this.list) {
            this.fetchList();
        }
    },
    methods: {
        removeTopBorder(e, index) {
            if (index) {
                e.target.parentElement.childNodes[index].classList.add('no-border');
            }
        },
        addTopBorder(e, index) {
            if (index) {
                e.target.parentElement.childNodes[index].classList.remove('no-border');
            }
        },
        setItemIndex(index) {
            this.itemIndex = index;
        },
        setTitle(e) {
            if (this.titleTimer) clearInterval(this.titleTimer);
            const self = this;
            this.titleTimer = setTimeout(
                function () {
                    const titleRect = self.$refs.tooltipTitle.getBoundingClientRect()
                    const titleWidth = titleRect.width;
                    const titleHeight = titleRect.height;
                    const containerRect = self.$refs.tooltipContainer.getBoundingClientRect();
                    if ((containerRect.bottom - e.clientY) <= titleHeight) {
                        self.coords.y = (e.clientY - containerRect.top - titleHeight);
                    } else {
                        self.coords.y = e.clientY - containerRect.top;
                    }
                    if ((containerRect.right - e.clientX) <= titleWidth) {
                        self.coords.x = (e.clientX - containerRect.left - titleWidth);
                    } else {
                        self.coords.x = e.clientX - containerRect.left;
                    }
                    self.isTitleDisplay = true;
                },
                2000
            )
        },
        resetTitle() {
            this.isTitleDisplay = false;
        },
        readCurrNotification(id) {
            this.readNotification(id)
            this.list.forEach(item => item.notificationId === id ? item.readAt = 'read' : item)
        },
        readNotifications() {
            this.readAllNotifications()
            this.list.forEach(item => item.readAt = 'read')
        },
        ...mapActions({
            fetchList: `header/${HEADER_FETCH_NOTIFICATION_COURSES}`,
            removeNotification: `header/${HEADER_REMOVE_NOTIFICATION}`,
            readNotification: `header/HEADER_READ_NOTIFICATION`,
            readAllNotifications: `header/${HEADER_READ_ALL_NOTIFICATIONS}`,
            removeAllNotifications: `header/${HEADER_REMOVE_ALL_NOTIFICATIONS}`,
        }),
        ...mapMutations({
            changeShowTooltip: `header/${HEADER_NOTIFICATION_SHOW_TOOLTIP}`,
        }),
        removeCurrNotification(id) {
            this.removeNotification(id)
        },
    }
}
